module.exports = __webpack_public_path__ + "img/level-3.6c0327f3.svg";